export default {
    parameters: {
        landing_id: "CISauto1",
    },
    downtimeUrl: "https://it.kodland.tech",
    startPage: {
      image: "/welcome/quiz_project_girl.jpeg",
      title:
        "Ответьте на несколько вопросов и получите приглашение на БЕСПЛАТНЫЙ IT-КУРС для ребёнка",
      subtitle:
        "Вместе сделаем игру и покажем как превратить увлечение гаджетами в пользу на БЕСПЛАТНОМ онлайн-курсе программирования",
      button: "Вперед!🚀",
    },
    stopPage: {
        image: "/welcome/quiz_stop_page.jpg",
        title: "Благодарим Вас за выбор нашей образовательной платформы! К сожалению, планшеты и смартфоны не подходят для наших занятий. Мы надеемся, что скоро появится возможность увидеть ас в числе наших учеников!",
    },
    quizRotateBySteps: {
      1: {
        question: "Как Ваш ребенок проводит свободное время?",
        answers: [
            "📱 Сидит в гаджетах, играет на компьютере или телефоне", 
            "💪 Посещяет спортивные секции",
            "👀 Смотрит мультфильмы или YouTube",
            "🎨 Занимается творчеством",
            "🤝 Проводит время с друзьями",
        ],
      },
      2: {
        question: "Какой любимый предмет в школе у Вашего ребенка?",
        answers: [
            "🖥 Информатика", 
            "🔢 Математика",
            "🎨 Искусство, живопись, дизайн",
            "📚 Литература",
            "🗣 Иностранный язык",
            "❓ Не могу ответить на этот вопрос",
        ],
      },
      3: {
        title: "В какое время Вам удобно прийти на первое занятие курса?",
        type: "timeslot",
        subtitle:
          "Осталось всего несколько шагов! Вы близки к завершению регистрации на курс. Мы уже ждем Вас!🥳",
        button: "Записаться!",
      },
      4: {
        question: "Умеет ли Ваш ребенок пользоваться компьютером?",
        answers: [
          "🤝 Да, знает базовые программы. Например Microsoft Word/Power Point",
          "🎮 Да, любит играть в видеоигры. например Roblox, Minecraft",
          "🖥 Да, знает некоторые основы программирования",
          "🛑 Нет",
        ],
      },
      5: {
        question: "Есть ли у Вас компьютер, который можно использовать для обучения?",
        answers: [
          "✅ Да",
          {
            answer: "❌ Нет",
            stopAnswer: true
          },
        ],
      },
      6: {
        title: "Сколько лет Вашему ребенку?",
        type: "age",
        subtitle: "Выберите возраст ребенка",
        button: "Вперед",
      },
      7: {
        title: "Как зовут Вашего ребенка?",
        type: "child_name",
        subtitle:
          "Данные, которые Вы нам предоставляете, защищены и будут удалены в случае необходимости🚨",
        button: "Вперед",
      },
      8: {
        title: "Введите адрес электронной почты",
        type: "mail",
        subtitle: "Не беспокойтесь, никакого спама😅",
        button: "Вперед",
      },
      9: {
        title: "Введите номер телефона",
        type: "phone",
        subtitle: "Мы будем использовать его, чтобы сообщить Вам важную информацию📞!",
        button: "Вперед",
      },
      10: {
        title: "Вставьте Ваше имя",
        type: "parent_name",
        subtitle: "Нас зовут - Кодленд, а Вас? 👋",
        button: "Завершить запись",
      },
    },
  };
  